import React from 'react';
import { MenuIcon } from 'lucide-react';
import { useMobileMenu } from '../hooks/useMobileMenu';
export function Header() {
  const {
    isOpen,
    toggle
  } = useMobileMenu();
  return <header className="bg-white/95 backdrop-blur-sm sticky top-0 z-40 border-b border-slate-200" data-id="element-47">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" aria-label="Primary" data-id="element-48">
        <div className="flex justify-between items-center" data-id="element-49">
          <a href="#hero" className="flex items-center gap-2" aria-label="SCIENS Technologies Home" data-id="element-50">
            <span className="text-2xl sm:text-3xl font-extrabold text-blue-600" data-id="element-51">
              SCIENS
            </span>
            <span className="text-2xl sm:text-3xl font-extrabold text-slate-900" data-id="element-52">
              Technologies
            </span>
          </a>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center gap-6" data-id="element-53">
            <a href="#services" className="text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors" data-id="element-54">
              Services
            </a>
            <a href="#process" className="text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors" data-id="element-55">
              Approach
            </a>
            <a href="#technology" className="text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors" data-id="element-56">
              Architecture
            </a>
            <a href="#expertise" className="text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors" data-id="element-57">
              Expertise
            </a>
            <a href="#start" className="bg-blue-600 text-white hover:bg-blue-700 px-5 py-2 rounded-lg text-sm font-semibold shadow-sm transition-colors" data-id="element-58">
              Get Started
            </a>
          </div>

          {/* Mobile menu button */}
          <button onClick={toggle} className="md:hidden inline-flex items-center justify-center rounded-md p-2 text-slate-600 hover:text-blue-600 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-blue-600 transition-colors" aria-expanded={isOpen} aria-controls="mobileMenu" aria-label="Open Menu" data-id="element-59">
            <MenuIcon className="h-6 w-6" data-id="element-60" />
          </button>
        </div>

        {/* Mobile menu */}
        {isOpen && <div id="mobileMenu" className="md:hidden pt-4 pb-6 space-y-2" data-id="element-61">
            <a href="#services" className="block px-3 py-2 rounded-md text-slate-800 hover:bg-slate-100 transition-colors" data-id="element-62">
              Services
            </a>
            <a href="#process" className="block px-3 py-2 rounded-md text-slate-800 hover:bg-slate-100 transition-colors" data-id="element-63">
              Approach
            </a>
            <a href="#technology" className="block px-3 py-2 rounded-md text-slate-800 hover:bg-slate-100 transition-colors" data-id="element-64">
              Architecture
            </a>
            <a href="#expertise" className="block px-3 py-2 rounded-md text-slate-800 hover:bg-slate-100 transition-colors" data-id="element-65">
              Expertise
            </a>
            <a href="#start" className="block px-3 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors" data-id="element-66">
              Get Started
            </a>
          </div>}
      </nav>
    </header>;
}